<template lang="pug">
  .vue-calendar
    template(v-if="range")
      div(v-for="index in 7", style="text-align: center;")
        slot(name="header" :index="index" :daysNames="daysNames")
          | {{ daysNames[index] }}

      .day(v-for="(date, index) in range", :style="date.style", :key="index")

        slot(:date="date", :dateIndex="index")
          div {{ date.pretty }}

    template(v-else="")
      p Período muito longo

</template>

<script>
import { rangeDates } from '../../utils'

export default {
  props: {
    startDate: {required: true}, // Date object
    endDate: {required: true},
    dayFormat: {'default': 'DD'}
  },
  data () {
    return {
      daysNames: {
        1: 'seg',
        2: 'ter',
        3: 'qua',
        4: 'qui',
        5: 'sex',
        6: 'sáb',
        7: 'dom'
      }
    }
  },
  computed: {
    range () {
      const dates = rangeDates(this.startDate, this.endDate)

      if (dates.length > 200) { return null }

      return dates.map((date, index) => {
        return {
          date,
          index,
          pretty: date.format(this.dayFormat),
          day: date.day(),
          style: index === 0
            ? {'grid-column': date.day() === 0 ? '7' : date.day()}
            : {}
        }
      })
    }
  }
}
</script>
<style scoped>
.vue-calendar {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(7, 1fr);
}
.vue-calendar > .day {
  display: grid;
  /*height: 60px;*/
  justify-content: stretch;
  background-color: whitesmoke;
  color: black;
  border-radius: 5px;
}
</style>
